import React, { useState } from 'react';
import { Save, Plus, Trash2 } from 'lucide-react';
import { apiCall, useAdminData, StringListEditor } from './_helpers';

const PrivateEventsManager = ({ onMessage }) => {
  const [items, setItems, refetch] = useAdminData('private-events');
  const [creating, setCreating] = useState(null);

  const save = async () => {
    try { await apiCall('POST', 'private-events', creating); onMessage('success', 'Saved'); setCreating(null); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };
  const remove = async (id) => {
    if (!window.confirm('Delete this package?')) return;
    try { await apiCall('DELETE', `private-events/${id}`); onMessage('success', 'Deleted'); refetch(); }
    catch (e) { onMessage('error', e.message); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Private Event Packages</h2>
        <button onClick={() => setCreating({ name: '', description: '', capacity: '', features: [], is_active: true })}
          className="bg-[#C9A86C] text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-[#B8956A]">
          <Plus size={18} /> Add Package
        </button>
      </div>
      {creating && (
        <div className="bg-white rounded-xl p-6 shadow-md mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" placeholder="Package Name" value={creating.name} onChange={(e) => setCreating({ ...creating, name: e.target.value })} className="border rounded-lg px-4 py-2" />
            <input type="text" placeholder="Capacity" value={creating.capacity} onChange={(e) => setCreating({ ...creating, capacity: e.target.value })} className="border rounded-lg px-4 py-2" />
            <textarea placeholder="Description" value={creating.description} onChange={(e) => setCreating({ ...creating, description: e.target.value })} className="border rounded-lg px-4 py-2 md:col-span-2" rows={2} />
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-2">Features</label>
              <StringListEditor items={creating.features || []} onChange={(features) => setCreating({ ...creating, features })} placeholder="Feature text" />
            </div>
          </div>
          <div className="flex gap-2 mt-4">
            <button onClick={save} className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"><Save size={18} /> Save</button>
            <button onClick={() => setCreating(null)} className="bg-gray-500 text-white px-4 py-2 rounded-lg">Cancel</button>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((item) => (
          <div key={item._id} className="bg-white rounded-xl p-6 shadow-md">
            <div className="flex justify-between items-start mb-3">
              <div>
                <h3 className="text-xl font-semibold">{item.name}</h3>
                <span className="text-[#C9A86C] text-sm">{item.capacity}</span>
              </div>
              <button onClick={() => remove(item._id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 size={18} /></button>
            </div>
            <p className="text-gray-600 mb-3">{item.description}</p>
            <div className="space-y-1">
              {(item.features || []).map((f, idx) => <p key={idx} className="text-sm text-gray-500">• {f}</p>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivateEventsManager;
